// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"791":"423b646c","969":"1dd80066"}[chunkId] + ".chunk.js";
};